import { defineStore } from 'pinia';
import { type Ref, ref } from 'vue';

export const useLoadingStore = defineStore('loading', () => {
  const isLoading: Ref<boolean> = ref(false);

  const set = (val: boolean) => {
    isLoading.value = val;
  };

  return {
    isLoading,
    set,
  };
});
